export default __webpack_public_path__ + "static/media/ad_970x90_install.9a7695e6.png";